<template>
    <div id="footerPage">
        <img class="img1" src="../assets/image/steam/footer.png" alt=""> 
        <img class="img2" src="../assets/image/steam/footer1.png" alt="" v-if="$route.name!='waitingPage' && $route.name!='percentage'">
    </div>
  
</template>

<script>


export default {
    name:'footerPage',
    props:{

    },
    data(){
        return{
            
        }
    },
    mounted(){
        
    }

}
</script>

<style>

#footerPage .img1{
    width: 6.35rem;
    height: 0.7rem;
    display: inline-block;
    margin-right: 1.3rem;
}
#footerPage .img2{
    width: 0.4rem;
    height: 0.65rem;
    display: inline-block;
}

</style>